export const API_URL = 'permissions'
export const ROUTE_NAME = 'permissions'
